(function () {
  var root = document.querySelector('[data-om-pdp]');
  if (!root) return;

  var unitCents = parseInt(root.getAttribute('data-unit-cents') || '0', 10);
  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  var qtyInput = root.querySelector('[data-om-qty]');
  var packProp = root.querySelector('[data-om-pack-prop]');
  var saveProp = root.querySelector('[data-om-save-prop]');
  var atcPrice = root.querySelector('[data-om-atc-price]');
  var stickyPrice = root.querySelector('[data-om-sticky-price]');
  var sticky = root.querySelector('[data-om-sticky-atc]');
  var buybox = root.querySelector('#om-buybox');
  var packs = root.querySelectorAll('[data-om-packs] .om-pack');

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function packTotal(qty, savePct) {
    var raw = unitCents * qty;
    return Math.round((raw * (100 - savePct)) / 100);
  }

  function syncPackPrices() {
    packs.forEach(function (pack) {
      var input = pack.querySelector('input[type="radio"]');
      var priceEl = pack.querySelector('[data-pack-price]');
      if (!input || !priceEl) return;
      var qty = parseInt(input.value, 10) || 1;
      var save = parseInt(input.getAttribute('data-save') || '0', 10);
      priceEl.textContent = formatMoney(packTotal(qty, save));
    });
  }

  function selectPack(pack) {
    var input = pack.querySelector('input[type="radio"]');
    if (!input) return;
    packs.forEach(function (p) {
      p.classList.remove('is-active');
    });
    pack.classList.add('is-active');
    input.checked = true;

    var qty = parseInt(input.value, 10) || 1;
    var save = parseInt(input.getAttribute('data-save') || '0', 10);
    var total = packTotal(qty, save);
    var money = formatMoney(total);

    if (qtyInput) qtyInput.value = String(qty);
    if (packProp) {
      packProp.value =
        input.getAttribute('data-pack-label') ||
        (qty === 1 ? '1 Month Supply' : qty === 2 ? '2 Month Supply' : '3 Month Supply');
    }
    if (saveProp) saveProp.value = save + '%';
    if (atcPrice) atcPrice.textContent = money;
    if (stickyPrice) stickyPrice.textContent = money;
  }

  packs.forEach(function (pack) {
    pack.addEventListener('click', function () {
      selectPack(pack);
    });
    var input = pack.querySelector('input');
    if (input) {
      input.addEventListener('change', function () {
        selectPack(pack);
      });
    }
  });

  syncPackPrices();
  var active = root.querySelector('[data-om-packs] .om-pack.is-active') || packs[0];
  if (active) selectPack(active);

  // Gallery
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.om-thumb'));
  var main = root.querySelector('[data-gallery-main]');
  var idx = 0;

  function show(i) {
    if (!thumbs.length || !main) return;
    idx = (i + thumbs.length) % thumbs.length;
    var t = thumbs[idx];
    main.src = t.getAttribute('data-full-src');
    thumbs.forEach(function (el, n) {
      el.classList.toggle('is-active', n === idx);
    });
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () {
      show(i);
    });
  });

  var prev = root.querySelector('[data-gallery-prev]');
  var next = root.querySelector('[data-gallery-next]');
  if (prev)
    prev.addEventListener('click', function () {
      show(idx - 1);
    });
  if (next)
    next.addEventListener('click', function () {
      show(idx + 1);
    });

  // FAQ: one open at a time
  var faqItems = root.querySelectorAll('[data-om-faq] details');
  faqItems.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      faqItems.forEach(function (other) {
        if (other !== item) other.open = false;
      });
    });
  });

  // Sticky ATC — show after buybox leaves view
  if (sticky && buybox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) sticky.setAttribute('hidden', '');
          else sticky.removeAttribute('hidden');
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    io.observe(buybox);
  }

  // Customer reviews: filter + show more
  var reviewsRoot = root.querySelector('[data-om-reviews-full]');
  if (reviewsRoot) {
    var chips = reviewsRoot.querySelectorAll('[data-om-review-chips] button');
    var items = Array.prototype.slice.call(reviewsRoot.querySelectorAll('[data-om-review-list] .om-reviews-full__item'));
    var moreBtn = reviewsRoot.querySelector('[data-om-reviews-more]');
    var activeRating = 'all';
    var expanded = false;

    function applyReviews() {
      var shown = 0;
      items.forEach(function (item) {
        var rating = item.getAttribute('data-rating') || '5';
        var match =
          activeRating === 'all' ||
          (activeRating === '3' ? parseInt(rating, 10) <= 3 : rating === activeRating);
        if (!match) {
          item.setAttribute('hidden', '');
          return;
        }
        if (!expanded && shown >= 4) {
          item.setAttribute('hidden', '');
          return;
        }
        item.removeAttribute('hidden');
        shown += 1;
      });
      if (moreBtn) {
        var remaining = items.filter(function (item) {
          var rating = item.getAttribute('data-rating') || '5';
          var match =
            activeRating === 'all' ||
            (activeRating === '3' ? parseInt(rating, 10) <= 3 : rating === activeRating);
          return match;
        }).length;
        moreBtn.hidden = remaining <= 4 || expanded;
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          c.classList.remove('is-active');
        });
        chip.classList.add('is-active');
        activeRating = chip.getAttribute('data-rating') || 'all';
        expanded = false;
        applyReviews();
      });
    });
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        expanded = true;
        applyReviews();
      });
    }
    applyReviews();
  }
})();
